export enum AddModeratorActionTypes {
  ADDING = 'moderators/ADDING',
  ADDED = 'moderators/ADDED',
  ERROR = 'moderators/ADD-ERROR',
}
